export default function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// /Users/diego/DevKinsta/public/musicalgreasees/wp-content/themes/greasetema/node_modules/@popperjs/core/lib/utils/expandToHashMap.js
// module id = 31
// module chunks = 0